function isDataUrl(value: string | null): boolean {
    return Boolean(value && value.startsWith("data:"))
}
function isUrlValue(value: string | null): boolean {
    return Boolean(value && (value.startsWith("http://") || value.startsWith("https://") || value.startsWith("/")))
}
function isBase64Value(value: string | null): boolean {
    return Boolean(value && !isDataUrl(value) && !isUrlValue(value))
}

const utils = {
    isDataUrl,
    isUrlValue,
    isBase64Value
}

export { utils as imageUploadUtils }
